module.exports = {
  apiHost: "https://api.vantagebloomdale.sensoreal.com.au",
  assetsHost: "https://assets.vantagebloomdale.sensoreal.com.au",

  header: {
    text: {
      en: "Your Vantage Bloomdale Selections",
    },
    logo: "",
    color: "#fff",
  },
  footerLogo:
    "https://static-mbh.sgp1.cdn.digitaloceanspaces.com/avid-edm/general/AVID_White_72dpi.png",
  langs: [{ code: "en", dir: "ltr" }],
  currency: {
    locale: "en-AU",
    code: "AUD",
  },
  style: {
    primaryColor: "#2f4b5b",
    textColor: "#fff",
  },
  contact: {
    website: "https://vantagebloomdale.avid.com.au",
    address: "1 Hero Street<br>Diggers Rest, VIC 3427",
    phone: "1800 826 000",
    email: "vantagebloomdale@avid.com.au",
  },
  links: {
    privacy: "",
    youtube: "https://www.youtube.com/channel/UCEnh4QABTOnsovDd-Hg45OQ",
    linkedin: "https://au.linkedin.com/company/avid-property-group",
    twitter: "",
    instagram: "https://www.instagram.com/avid_together/",
    facebook: "https://www.facebook.com/vantage.bloomdale",
  },
};
